import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, Paper, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';

function UserManagementHeader({
  searchText, searchTextPlaceHolder, handleSearchChange, usersCount, groupsCount, addNewUserHandler, addNewgroupHandler, user_permission,
}) {
  return (
    <Box
      sx={{
        paddingLeft: '16px',
        paddingRight: '16px',
      }}
    >
      <div className="flex flex-col justify-between mb-4 md:mb-8 md:flex-row md:items-center">
        <div>
          <Box sx={{ padding: '20px' }}>
            <Typography
              variant="h3"
              sx={{
                color: '#384451',
                marginBottom: 1,
              }}
            >
              User Management
            </Typography>
            <Typography variant="body1" sx={{ marginBottom: 3 }}>
              Manage user access and group permissions
            </Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Box>
                <Box
                  sx={{
                    marginBottom: 0,
                    width: '300px',
                  }}
                >
                  <TextField
                    variant="outlined"
                    value={searchText}
                    placeholder={searchTextPlaceHolder}
                    fullWidth
                    onChange={handleSearchChange}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      style: {
                        borderRadius: 30,
                        backgroundColor: '#E0F0F8',
                        height: '45px',
                      },
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </div>
        <Stack direction="column" gap={2}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
            }}
          >
            <Paper
              elevation={1}
              sx={{
                borderRadius: '20px',
                padding: 1,
                textAlign: 'left',
                width: 150,
                border: '2px solid #5A9EA8',
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  color: '#5A9EA8',
                  fontWeight: 'bold',
                }}
              >
                Total Users
              </Typography>
              <Typography variant="h4">
                <center>{usersCount}</center>
              </Typography>
            </Paper>
            <Paper
              elevation={1}
              sx={{
                borderRadius: '20px',
                padding: 1,
                textAlign: 'left',
                width: 150,
                border: '2px solid #5A9EA8',
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{
                  color: '#5A9EA8',
                  fontWeight: 'bold',
                }}
              >
                Groups
              </Typography>
              <Typography variant="h4">
                <center>{groupsCount}</center>
              </Typography>
            </Paper>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<PersonAddIcon />}
              sx={{
                borderRadius: '20px',
                width: 150,
                height: 40,
                backgroundColor: '#384451',
              }}
              onClick={addNewUserHandler}
            >
              Add User
            </Button>
            {user_permission === 'Admin' && (
              <Button
                variant="contained"
                startIcon={<GroupAddIcon />}
                sx={{
                  borderRadius: '20px',
                  width: 150,
                  height: 40,
                  backgroundColor: '#384451',
                }}
                onClick={addNewgroupHandler}
              >
                Add Group
              </Button>
            )}
          </Box>
        </Stack>
      </div>
    </Box>
  );
}

export default UserManagementHeader;
